import React from "react";
import { useNavigate } from "react-router";
import RequestCard from "./RequestCard";
const RequestsList = ({ data, signButton }) => {
  const navigate = useNavigate();
  const handlePage = (data) => {
    if (data.payment_request_type === "pending") {
      navigate(`/payment-requests/${data._id}`, {
        state: data,
      });
    } else {
      navigate(`/payment-request-details/${data._id}`, {
        state: data,
      });
    }
  };

  return (
    <div className="col-lg-12">
      {data.map((bill, index) => {
        return (
          <RequestCard
            bill={bill}
            handlePage={handlePage}
            btn_title={
              bill.payment_request_type == "pending"
                ? bill.plan.trial_period_days > 0
                  ? "Begin Free Trial"
                  : "Make Payment"
                : "View Details"
            }
            signButton={signButton}
            key={index}
          />
        );
      })}
    </div>
  );
};

export default RequestsList;
